import './LoginPage.scss';

import useAuth from 'common/useAuth';
import { PublicPage } from 'components/Layout';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useCallback } from 'react';

import type { LoginFormValues } from './components/LoginForm';
import LoginPart from './components/LoginPart';
import type { TenantCodeFormValues } from './components/TenantCodeForm';
import TenantPart from './components/TenantPart';

interface Props {}

const LoginPage: React.FC<Props> = (): React.ReactElement => {
  const { t } = useCustomTranslation();

  const { login, setTenant, tenantCode, refreshTokenFailed } = useAuth();

  const handleLogin = useCallback(
    async (values: LoginFormValues) => {
      await login(values);
    },
    [login]
  );

  const handleTenant = useCallback(
    async (values: TenantCodeFormValues) => {
      await setTenant(values);
    },
    [setTenant]
  );

  return (
    <PublicPage title={t('login.title')} className="LoginPage">
      <div className="LoginPage_content white-box">
        {tenantCode ? (
          <LoginPart handleLogin={handleLogin} refreshTokenFailed={refreshTokenFailed} />
        ) : (
          <TenantPart handleTenant={handleTenant} />
        )}
      </div>
    </PublicPage>
  );
};

export default LoginPage;
